import { Component, OnInit } from '@angular/core';
import { UpgradeStore } from 'src/app/shared/_services/store/upgradeStore.service';

@Component({
  selector: 'app-platinum',
  templateUrl: './platinum.page.html',
  styleUrls: ['./../gold/gold.page.scss'],
})
export class PlatinumPage implements OnInit {
  constructor(private upgradeStore: UpgradeStore) {}

  ionViewWillEnter() {
    this.upgradeStore.setIsBusinessRegistered(true);
  }

  ngOnInit() {
  }
}
